import { useRef } from 'react'
import { GET_QUALIFICATION_CONFIG_BY_MATERIAL } from '../../../api/categoryQualificationApi'
import { AptitudeConfigParam } from './typing'

// 资质配置获取：按「物料编码 + 四级类目主键ID + 资质场景」查询必传资质类型
// 入参合并存储；类目与场景齐备才查询，否则返回 undefined（页面跳过更新）。
// requiredAttachTypes 不在本 hook 内部存储——交由页面 reducer 保存，
// 以便切换 tab 时随页面状态一起缓存/恢复。
export default function useAptitudeConfig() {
  const paramRef = useRef<AptitudeConfigParam>({})

  // 返回必传资质类型 value 数组；类目与场景齐备才查询，否则返回 undefined
  const getAptitudeConfig = async (
    param: AptitudeConfigParam,
  ): Promise<string[] | undefined> => {
    paramRef.current = { ...paramRef.current, ...param }
    const { materialCode, cateMdmId, scene, owner } = paramRef.current
    if (!cateMdmId || !scene) return undefined
    const res = await GET_QUALIFICATION_CONFIG_BY_MATERIAL({
      materialCode,
      cateMdmId,
      scene,
      ownerCode: owner,
    })
    if (res.code === 0) return res.data || []
    return undefined
  }

  return { getAptitudeConfig }
}
import { useRef } from 'react'
import { GET_QUALIFICATION_CONFIG_BY_MATERIAL } from '../../../api/categoryQualificationApi'
import { AptitudeConfigParam } from './typing'

// 资质配置获取：按「物料编码 + 四级类目主键ID + 资质场景」查询必传资质类型
// 入参合并存储；类目与场景齐备才查询，否则返回 undefined（页面跳过更新）。
// requiredAttachTypes 不在本 hook 内部存储——交由页面 reducer 保存，
// 以便切换 tab 时随页面状态一起缓存/恢复。
export default function useAptitudeConfig() {
  const paramRef = useRef<AptitudeConfigParam>({})

  // 返回必传资质类型 value 数组；类目与场景齐备才查询，否则返回 undefined
  const getAptitudeConfig = async (
    param: AptitudeConfigParam,
  ): Promise<string[] | undefined> => {
    paramRef.current = { ...paramRef.current, ...param }
    const { materialCode, cateMdmId, scene, owner } = paramRef.current
    if (!cateMdmId || !scene) return undefined
    const res = await GET_QUALIFICATION_CONFIG_BY_MATERIAL({
      materialCode,
      cateMdmId,
      scene,
      ownerCode: owner,
    })
    if (res.code === 0) return res.data || []
    return undefined
  }

  return { getAptitudeConfig }
}
